import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jbqutfkjxx: FaireBrandEntity = {
  token: "b_jbqutfkjxx",
  type: "brand",
  name: "The Clandestine Underground",
  avatarUrl:
    "https://cdn.faire.com/fastly/2f3d1a971bd4e9cf16e471fdb14ad5e37b892514b0755a0cbe25965ac4add9e1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3aa699366bb24fc5b23e65dfb1160104d47bd24c0e86bdb8ccb74cf7de61b1cd.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2f3d1a971bd4e9cf16e471fdb14ad5e37b892514b0755a0cbe25965ac4add9e1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3aa699366bb24fc5b23e65dfb1160104d47bd24c0e86bdb8ccb74cf7de61b1cd.png",
  location: "Memphis, TN, USA",
  minimumOrderDollars: 173,
  rating: 4.9,
  reviewCount: 121,
  isTopShop: true,
  isInsider: true,
  description:
    "* NOTE WE ARE A SMALL BUSINESS & MAKE ALL PRODUCTS TO ORDER MAKING OUR AVERAGE LEAD TIME 8-12 BUSINESS DAYS *\n\n** We will be attending Dallas Market this March 24-27. We will be located on Floor 12 at booth #12-4000 **\n\nWelcome to The Clandestine Underground - A unique blend of creativity and sustainability, founded in 2020 by a passionate woman. Our ethos? To offer eclectic, retro-inspired streetwear, including oversized t-shirts and sweatshirts, all designed and crafted in-house with care and individuality. Each piece reflects our dedication to originality and personal expression.\n\nSustainability is our signature. Our eco-friendly approach extends to our packaging, ensuring everything is recyclable, compostable, or biodegradable. We're committed to reducing our environmental footprint, one step at a time.\n\nFashion with Purpose: We're not just selling clothes; we're fostering change. A portion of our proceeds supports charities across animal rescue, social justice, environmental protection, and women's empowerment. By choosing The Clandestine Underground, you're joining a movement that dresses with intention and impacts with heart.\n\nBe Unique. Be Conscious. Be Part of Our Journey. Join us in celebrating individuality and promoting a more sustainable, equitable world. Together, we can make a difference.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:42.863Z",
    importedBy: "entity-db-cli",
  },
};
